export async function apiRequest<T>(url: string): Promise<T> {
    try {
        const response = await fetch(url, { headers: { 'Content-Type': 'application/json' } });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`API call failed with status ${response.status}: ${errorText}`);
        }
        return await response.json() as T;
    } catch (error) {
        console.error("Failed to fetch data:", error);
        throw error;  // Let the calling function handle the exception
    }
    
}
